import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const nameMap: Record<string, string> = {};
categories.forEach((c) => { nameMap[`/category/${c.slug}`] = c.name; });
articles.forEach((a) => { nameMap[`/article/${a.slug}`] = a.title; });
nameMap['/about'] = '关于我们';

function getBreadcrumbs(pathname: string) {
  const crumbs = [{ label: '首页', path: '/' }];
  if (pathname === '/') return crumbs;

  const segments = pathname.split('/').filter(Boolean);

  if (segments[0] === 'category' && segments[1]) {
    crumbs.push({ label: nameMap[pathname] || segments[1], path: pathname });
  } else if (segments[0] === 'article' && segments[1]) {
    const article = articles.find((a) => a.slug === segments[1]);
    if (article) {
      crumbs.push({ label: categories.find((c) => c.slug === article.category)?.name || '分类', path: `/category/${article.category}` });
      crumbs.push({ label: article.title, path: pathname });
    }
  } else if (segments[0] === 'about') {
    crumbs.push({ label: '关于我们', path: '/about' });
  }

  return crumbs;
}

export default function Breadcrumb() {
  const location = useLocation();
  const crumbs = getBreadcrumbs(location.pathname);

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
        {crumbs.map((crumb, i) => (
          <li key={crumb.path} className="flex items-center gap-1">
            {i > 0 && <span className="mx-1 text-foreground-400">/</span>}
            {i === crumbs.length - 1 ? (
              <span className="text-foreground-700 font-medium">{crumb.label}</span>
            ) : (
              <Link to={crumb.path} className="hover:text-primary-600 transition-colors cursor-pointer">
                {crumb.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}